var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('label',{staticClass:"block tracking-wide text-sm font-bold",class:[
      _vm.hasError ? 'text-red-700' : 'text-gray-600',
      _vm.label ? 'mb-2' : ''
    ]},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('input',{class:_vm.inputClass,attrs:{"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder,"disabled":_vm.readOnly},domProps:{"value":_vm.model},on:{"input":_vm.onInput,"focus":_vm.onFocus}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }